// Version : 0.0.2
// Author : Nandhakumar
// LastAdd : 'Converted Existed Values for the Keys from Upper Case to Smaller Case'
// Modified Date : 4-12-2025

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** GET GOLD LOAN INDEX DETAILS START *********************** */
export const fetchGoldLoanIndexDetails = (listData: any) => {
	const data = {
		GetGoldLoanIndexDetailsToken: listData,
	};
	const url = `${API_URL}getSearchGoldDetailsForGoldLoan`;
	return makeApiCall(url, data);
};
/** ***************** GET GOLD LOAN INDEX DETAILS END *********************** */

/** *****************GET GOLD LOAN INDEX INFO START *********************** */
export const fetchGoldLoanIndexInfo = (listData: any) => {
	const data = {
		getLoanInfoBasedOnGoldLoanIndexDataToken: listData,
	};
	const url = `${API_URL}getLoanInfoBasedOnGoldLoanIndex`;
	return makeApiCall(url, data);
};
/** *****************GET GOLD LOAN INDEX INFO END *********************** */

/** *****************DELETE GOLD LOAN INDEX START *********************** */
export const deleteGoldLoanIndex = (listData: any) => {
	const data = {
		GoldLoanIndexDeleteToken: listData,
	};
	const url = `${API_URL}deleteGoldLoan`;
	return makeApiCall(url, data);
};
/** *****************DELETE GOLD LOAN INDEX END *********************** */

/** *****************GET PARTICULAR GOLD LOAN INDEX INFO START *********************** */
export const fetchParticularGoldLoanIndexInfo = (listData: any) => {
	const data = {
		GetParticularGoldLoanIndexToken: listData,
	};
	const url = `${API_URL}getParticularGoldLoanIndexInfo`;
	return makeApiCall(url, data);
};
/** *****************GET PARTICULAR GOLD LOAN INDEX INFO END *********************** */

/** *****************UPDATE GOLD LOAN INDEX COLLECTION START *********************** */
export const updateGoldLoanIndexCollection = (listData: any) => {
	const data = {
		UpdateGoldLoanPaymentDetailsToken: listData,
	};
	const url = `${API_URL}updateGoldLoanPaymentDetails`;
	return makeApiCall(url, data);
};
/** *****************UPDATE GOLD LOAN INDEX COLLECTION END *********************** */

/** ***************** GET MEMBER GOLD COLLECTION DETAILS START *********************** */
export const fetchMemberGoldCollectionDetails = (listData: any) => {
	const data = {
		GetMemberGoldCollectionDetailsToken: listData,
	};
	const url = `${API_URL}getMemberGoldCollectionDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER GOLD COLLECTION DETAILS END *********************** */
